<template>
    <el-select v-model="selectVal" :placeholder="placeholder" filterable clearable :multiple-limit="5" @change="toggleSelector">
        <el-option v-for="(item, index) in list" :key="index" :label="item.realname" :value="item.id"></el-option>
    </el-select>
</template>

<script>
import { post } from '@/api/http.js';
export default {
    props: {
        value: {
            type: [Array, String, Number],
            default: function () {
                return [];
            }
        },
        roles: {
            type: Array,
            default: function () {
                return [];
            }
        },
        withLeave: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        placeholder: {
            type: String,
            default: function () {
                return '请选择';
            }
        }
    },
    data() {
        return {
            selectVal: [],
            list: []
        };
    },
    created() {
        this.getUserList();
    },
    watch: {
        value: {
            handler(newVal) {
                this.val = newVal;
            },
            immediate: true
        }
    },
    methods: {
        getUserList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: this.roles
            };
            post(url, params).then((res) => {
                _this.list = res.data.list;
            });
        },
        toggleSelector() {
            this.$emit('input', this.selectVal);
        }
    }
};
</script>

<style>
</style>
